import * as React from 'react';
import { Subscriber } from 'react-broadcast';

interface FlagProps
{
    name: string;
}

// Flag component helps to render element conditionally when condition can change when component is mounted
type Props = Readonly<FlagProps> & Readonly<{ children?: React.ReactNode }>;
export const Flag:React.SFC<Props> = (props: Props) => (
    <Subscriber channel={props.name}>
        { isSet => isSet ? props.children : null }
    </Subscriber>
)


// WEBPACK FOOTER //
// ./src/components/Flag/Flag.tsx